import { create } from "zustand";

/** The 15 s undo window after a trash delete (`SlottingUndoBar` pattern, W6 WP8). */
export const GUEST_TRASH_UNDO_MS = 15_000;

export type GuestTrashUndoEntry = {
  eventId: string;
  /** `trashBatchId` of the delete — what `POST …/trash/restore {batchId}` undoes. */
  batchId: string;
  count: number;
  purgeAt: string | null;
  /** Epoch ms the pill disappears on its own. */
  expiresAt: number;
  /** Monotonic, so a second delete inside the window replaces the first pill. */
  seq: number;
};

type GuestTrashUndoState = {
  pending: GuestTrashUndoEntry | null;
  arm: (entry: Omit<GuestTrashUndoEntry, "expiresAt" | "seq">) => void;
  clear: (seq?: number) => void;
};

let seq = 0;

export const useGuestTrashUndo = create<GuestTrashUndoState>((set) => ({
  pending: null,
  arm: (entry) =>
    set({ pending: { ...entry, expiresAt: Date.now() + GUEST_TRASH_UNDO_MS, seq: ++seq } }),
  // With a `seq` only that pill is cleared — a timer of a replaced pill must
  // not take the newer one down with it.
  clear: (which) =>
    set((s) => (s.pending && (which === undefined || s.pending.seq === which) ? { pending: null } : s)),
}));

/** Imperative twin for callers outside React render (the delete lanes). */
export function armGuestTrashUndo(entry: Omit<GuestTrashUndoEntry, "expiresAt" | "seq">): void {
  useGuestTrashUndo.getState().arm(entry);
}
